"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const contact_1 = require("../contact");
const deserializeShipment = ({ createdAt, editedAt, carrierContact, customerContact, journey: { waypoints, ...restJourney }, ...rest }) => ({
    ...rest,
    carrierContact: carrierContact
        ? contact_1.deserializeContact(carrierContact)
        : undefined,
    customerContact: customerContact
        ? contact_1.deserializeContact(customerContact)
        : undefined,
    journey: {
        ...restJourney,
        waypoints: waypoints.map(({ arriveAtFrom, arriveAtTo, ...restWaypoint }) => ({
            ...restWaypoint,
            arriveAtFrom: arriveAtFrom ? new Date(arriveAtFrom) : undefined,
            arriveAtTo: arriveAtTo ? new Date(arriveAtTo) : undefined
        }))
    },
    createdAt: createdAt ? new Date(createdAt) : undefined,
    editedAt: editedAt ? new Date(editedAt) : undefined
});
exports.default = deserializeShipment;
